import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'timers-summary',
  templateUrl: './timers-summary.component.html',
  styleUrls: ['./timers-summary.component.scss']
})
export class TimersSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
